"use strict";
/**
 * CRM Types - Shared between mobile app and backoffice
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StageType = exports.CLIENT_TYPE_OPTIONS = exports.CRM_STATUS_ACTIONS_FIELD = exports.CLIENT_TRACKABLE_PORTAL_ACTIONS = exports.CUSTOMER_PORTAL_ACTIVITY_ACTIONS = exports.CrmActivityType = exports.SUB_STAGES = exports.STAGE_HIERARCHY = exports.MainStageType = void 0;
// Re-export stage types from existing model
var crm_stages_model_1 = require("./prompts/crm-stages.model");
Object.defineProperty(exports, "MainStageType", { enumerable: true, get: function () { return crm_stages_model_1.MainStageType; } });
Object.defineProperty(exports, "STAGE_HIERARCHY", { enumerable: true, get: function () { return crm_stages_model_1.STAGE_HIERARCHY; } });
Object.defineProperty(exports, "SUB_STAGES", { enumerable: true, get: function () { return crm_stages_model_1.SUB_STAGES; } });
/**
 * Activity types for CRM deal history tracking
 */
var CrmActivityType;
(function (CrmActivityType) {
    CrmActivityType["LEAD_CREATED"] = "lead_created";
    CrmActivityType["STAGE_CHANGED"] = "stage_changed";
    CrmActivityType["DEAL_UPDATED"] = "deal_updated";
    CrmActivityType["NOTE_ADDED"] = "note_added";
    CrmActivityType["NOTE_UPDATED"] = "note_updated";
    CrmActivityType["NOTE_DELETED"] = "note_deleted";
    CrmActivityType["CUSTOMER_PORTAL_ACTIVITY"] = "customer_portal_activity";
    CrmActivityType["WHATSAPP_ACTIVITY"] = "whatsapp_activity";
    CrmActivityType["CALL_SUMMARY"] = "call_summary";
})(CrmActivityType || (exports.CrmActivityType = CrmActivityType = {}));
exports.CUSTOMER_PORTAL_ACTIVITY_ACTIONS = [
    'portal_login_completed',
    'portal_viewed',
    'referral_viewed',
    'referral_whatsapp_clicked',
    'referral_link_copied',
    'visit_confirmation_completed',
    'report_downloaded',
    'visit_details_updated',
    'visit_change_requested',
    'visit_cancellation_requested',
    'calendar_added',
    'google_review_clicked',
];
exports.CLIENT_TRACKABLE_PORTAL_ACTIONS = [
    'referral_viewed',
    'referral_whatsapp_clicked',
    'referral_link_copied',
    'calendar_added',
    'google_review_clicked',
];
exports.CRM_STATUS_ACTIONS_FIELD = 'crmStatusActions';
exports.CLIENT_TYPE_OPTIONS = [
    { value: 'bedek', label: 'בדק בית' },
    { value: 'retivut', label: 'רטיבות' },
];
/**
 * Legacy stage enum for backward compatibility
 */
var StageType;
(function (StageType) {
    StageType["NEW"] = "new";
    StageType["CONTACT_MADE"] = "contact_made";
    StageType["QUOTE_SENT"] = "quote_sent";
    StageType["NEGOTIATION"] = "negotiation";
    StageType["WON"] = "won";
    StageType["LOST"] = "lost";
})(StageType || (exports.StageType = StageType = {}));
